// extracted by mini-css-extract-plugin
module.exports = {"rightMenuContent":"_355Mfc","innerContainer":"BZcueQ","shortcutButtonsContainer":"_1flgRs","shortcutButtonsHeader":"_1vTHD6"};